module.exports = __webpack_public_path__ + "img/901393861.c52ca826.png";